// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"24":"1bfc9850","176":"styles","348":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"16":"e168accc908019a94828","24":"86d561f8c297e94f7ed7","160":"a4919db31884ed47c223","176":"500c616631f208f6f68d","348":"bdf224fbef77511f436d","764":"c75a8dcdabda1f6a8578","832":"f9fe8c240c27ccee7409"}[chunkId] + ".js";
};